jQuery(document).ready(function($) {

	// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
	var keys = {37: 1, 38: 1, 39: 1, 40: 1};
	var containerCtr = 0, processSliderComplete = [], scrollLockPositions = [], $engagedContainer = false, engagedSlide = false, previousScrollY = false, pauseScrolling = false;

	//Actually change the visible slide
	var changeSlide = function($container, id, $slide) {
		if ($container.hasClass('mobile')) {
			$slide.show();
		} else {
			$slide.css('display', 'flex');
		}
		$container.find('.slide:not([data-id="' + id + '"])').hide();
	}

	var disableScroll = function() {
	  if (window.addEventListener) // older FF
	      window.addEventListener('DOMMouseScroll', preventDefault, false);
	  document.addEventListener('wheel', preventDefault, {passive: false}); // Disable scrolling in Chrome
	  //window.onwheel = preventDefault; // modern standard
	  //window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
	  window.ontouchmove  = preventDefault; // mobile
	  document.onkeydown  = preventDefaultForScrollKeys;
	}

	var enableScroll = function() {
	    if (window.removeEventListener)
	        window.removeEventListener('DOMMouseScroll', preventDefault, false);
	    document.removeEventListener('wheel', preventDefault, {passive: false}); // Enable scrolling in Chrome
	    window.onmousewheel = document.onmousewheel = null;
	    window.onwheel = null;
	    window.ontouchmove = null;
	    document.onkeydown = null;
	}

	var init = function() {
		var $this = $(this);

		$this.attr('data-process-slider-id', ++containerCtr);
		if ($this.css('zIndex') == 1) {
			return initForMobile($this);
		}
		initForDesktop($this);
	};

	//Initialize this component
	var initForDesktop = function($this) {
		console.log('desktop');
		var maxHeight = 0, $slides = $this.find('.container > div'), slideCount = $slides.length, slideNav = '<ul>', leftEdge = 0, navGap = 0, $slideNav, hidden = true;

		if ($this.css('display') != 'none') hidden = false;
		$this.show();
		$this.data('slides', slideCount);

		//Go through each slide
		$slides.each(function(i) {
			let slideHeight, $slide = $(this), $question = $slide.find('.question'), $nav, $questionContent = $question.children('div');

			/*
			if (i == 0) {
				leftEdge = (($(window).width() - $('#masthead').width()) / 2) - $questionContent.width() - parseFloat($questionContent.css('paddingLeft')) - parseFloat($questionContent.css('paddingRight'));
			}

			//add nav links
			$questionContent.css('paddingBottom', '5rem').append('<nav></nav>');
			$nav = $question.find('nav');
			switch (i) {
				case 0:
					$nav.append('<a class="next">Next Question</a>');
					break;
				case slideCount - 1:
					$nav.append('<a class="previous">Previous Question</a>');
					break;
				default:
					$nav.append('<ul><li><a class="previous">Previous Question</a></li><li><a class="next">Next Question</a></li>');
					$nav.addClass('both');
			}
			//Pad question divs to make room for left nav
			$question.addClass('has-nav');
			*/

			//Factor height
			slideHeight = $slide.height();
			if (slideHeight > maxHeight) maxHeight = slideHeight;
		});

		//Set all slides' heights
		//$slides.find('.question > div').css('height', maxHeight + 'px');
		$this.css('height', maxHeight + 'px');

		//Stack slides
		$this.addClass('browser');

		//Add nav
		/*
		for (let i = 0; i < slideCount; i++) {
			slideNav += '<li><a' + (i == 0 ? ' class="active"' : '') + ' href="#" data-id="' + (i + 1) + '">&nbsp;</a></li>';
		}
		slideNav += '</ul>';
		$this.prepend(slideNav);
		$slideNav = $this.children('ul');
		$slideNav.css({
			left: leftEdge + 'px'
		});
		navGap = $slideNav.height();
		navGap = navGap - (slideCount * 8); //Nav items are 8px tall
		navGap = Math.floor(navGap / (slideCount - 1)) + 'px';
		$slideNav.find('li').each(function(i) {
			if (i == 0) return;
			$(this).css('marginTop', navGap);
		});

		//Add listeners
		$slideNav.find('a').on('click', jumpSlide);
		$this.find('.previous').on('click', previousSlide);
		$this.find('.next').on('click', nextSlide);

		if ($slides.length > 0) {
			$($slides[0]).css('display', 'flex');
		}
		*/
		if (hidden) $this.hide();
	};

	//Initialize this component
	var initForMobile = function($this) {
		console.log('mobile init');
		return;
		var $container = $this.find('.container'), maxHeight = 0, $slides = $container.children('div'), slideCount = $slides.length;

		$this.data('slides', slideCount);

		//Go through each slide
		$slides.each(function(i) {
			let slideHeight, $slide = $(this), $content = $slide.children('div:first-child'), $graphic = $slide.children('div:last-child');

			//Factor height
			slideHeight = $content.height();
			if (slideHeight > maxHeight) maxHeight = slideHeight;
			slideHeight = $graphic.height();
			if (slideHeight > maxHeight) maxHeight = slideHeight;
		});

		//Set all slides' heights
		$slides.find('> div > div').css('height', maxHeight + 'px');
		$container.css('height', maxHeight + 'px');

		$(window).on('scroll', scrollListener);

		//Stack slides
		$this.addClass('browser');
		$this.addClass('mobile');
		$slides.hide();

		//Add listeners
		if ($slides.length > 0) {
			$($slides[0]).show();
			$($slides[0]).children('div:last-child').hide();
		}

		scrollLockPositions[$this.data('process-slider-id')] = $this[0].offsetTop - $this.height() + $('#masthead').height();
		processSliderComplete[$this.data('process-slider-id')] = false;
	};

	//Listener for jump links to the left of the challenges browser
	var jumpSlide = function(e) {
		e.preventDefault();

		var $this = $(this), id = $this.data('id'), $container = $this.parent().parent().parent(), $slide = $container.find('.slide[data-id="' + id + '"]');

		changeSlide($container, id, $slide);
	};

	//Next question link click listener
	var nextSlide = function(e) {
		var $this = $(this), $currentSlide = $this.parents('.slide'), currentId = $currentSlide.data('id'), $container = $currentSlide.parent(), nextId = currentId + 1, $nextSlide = $container.find('.slide[data-id="' + nextId + '"]');

		e.preventDefault();

		if ($nextSlide.length < 1) return;

		changeSlide($container, nextId, $nextSlide);
	};

	var preventDefault = function(e) {
	  e = e || window.event;
	  if (e.preventDefault) {
	      e.preventDefault();
	  }
	  e.returnValue = false;
	}

	var preventDefaultForScrollKeys = function(e) {
	    if (keys[e.keyCode]) {
	        preventDefault(e);
	        return false;
	    }
	}

	//Previous question link click listener
	var previousSlide = function(e) {
		var $this = $(this), $currentSlide = $this.parents('.slide'), currentId = $currentSlide.data('id'), $container = $currentSlide.parent(), previousId = currentId - 1, $previousSlide = $container.find('.slide[data-id="' + previousId + '"]');

		e.preventDefault();

		if ($previousSlide.length < 1) return;

		changeSlide($container, previousId, $previousSlide);
	};

	//Clear out listeners and dynamic content and rebuild when window is resized
	var reInit = function(e) {
		/*
		$('.challenge-data').each(function() {
			var $this = $(this), $slideNav = $this.children('ul'), $slides = $this.find('.slide'), hidden = true;
			$this.removeClass('browser');
			$this.removeClass('mobile');
			$slides.find('> div > div').removeAttr('style');
			if ($this.css('display') != 'none') hidden = false;
			$this.removeAttr('style');
			$slides.removeAttr('style');
			$slides.children('div').removeAttr('style');

			if (hidden) {
				$this.hide();
			}

			$slideNav.find('a').off('click', jumpSlide);
			$this.find('.previous').off('click', previousSlide);
			$this.find('.next').off('click', nextSlide);
			$this.find('.show-answer a').off('click', showAnswer);

			$this.find('nav').remove();
			$this.find('.show-answer').remove();
			$slideNav.remove();
		});
		*/
		$('.process-slider').each(init);
	}

	var scrollListener = function(e) {
		if (previousScrollY === false) {
			previousScrollY = window.scrollY;
			return;
		}
		var scrollDirection = window.scrollY - previousScrollY > 0 ? 1 : -1;
		previousScrollY = window.scrollY;
		if (pauseScrolling) return;
		pauseScrolling = true;
		setTimeout(unPauseScrolling, 300);
		for (var i in scrollLockPositions) {
			if (scrollLockPositions[i] && window.scrollY >= scrollLockPositions[i]) {
				console.log('found');
				if (engagedSlide === false) {
					console.log('not engaged');
					if (processSliderComplete[i] === false && scrollDirection == 1) {
						console.log('init');
						//Start slider
						engagedSlide = 1;
						window.scrollY = scrollLockPositions[i];
						return;
					}
				} else {
					var $container = $('.process-slider[data-process-slider-id="' + i + '"]');
					engagedSlide++;
					console.log('Slide: ' + engagedSlide);
					if (engagedSlide > $container.data('slides')) {
						console.log('Done');
						processSliderComplete[i] = true;
						engagedSlide = $container.data('slides');
						return;
					} else {
						window.scrollTo(0, scrollLockPositions[i]);
						console.log(window.scrollY);
						/*
						console.log('changing slide');
						console.log($container.find('.container'));
						console.log(engagedSlide, $container.find('.container').children('div:nth-child(' + engagedSlide + ')'));
						*/
						changeSlide($container, engagedSlide, $container.children('div:nth-child(' + engagedSlide + ')'));
					}

				}
			}
		}
	}

	var showAnswer = function(e) {
		var $question = $(this).parent().parent().parent(), $answer = $question.siblings();

		e.preventDefault();

		$answer.show();
		$question.hide();
		$question.parent().parent().children('ul').addClass('showing-answer');
	};

	var unPauseScrolling = function() {
		pauseScrolling = false;
	};

	$('.process-slider').each(init);
	$(window).on('resize', reInit);

});
